
import { Component, Vue } from 'vue-property-decorator';
import Create from './components/Create.vue';
import Notes from './components/Notes.vue';
import NoteModal from './components/NoteModal.vue';
import { namespace } from 'vuex-class';
import { Snackbar, Note } from './store/types';

const notesModule = namespace('notes');
const globalModule = namespace('global');

@Component({
  components: {
    Create,
    Notes,
    NoteModal,
  },
})
export default class App extends Vue {
  loading = true;
  refreshLoading = false;

  async created() {
    this.loading = true;
    await this.getNotes();
    this.loading = false;
  }

  async refresh() {
    this.refreshLoading = true;
    await this.getNotes();
    this.refreshLoading = false;
  }

  @globalModule.State
  snackbar!: Snackbar;

  @notesModule.Action
  getNotes!: () => Promise<Note[]>;
}
